"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductFeatures = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MatchHeight = require("../../../utils/MatchHeight");
var _ProductListItem = require("../ProductListItem/ProductListItem");
var _excluded = ["namespace", "productFeatures", "className", "styles"]; // CardProductFeatures
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CardProductFeatures = exports.CardProductFeatures = function CardProductFeatures(_ref, featGroupIndex) {
  var namespace = _ref.namespace,
    productFeatures = _ref.productFeatures,
    className = _ref.className,
    styles = _ref.styles,
    containerProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeight, _extends({
    name: "Card Features",
    key: "".concat(featGroupIndex + 1, "_match-height"),
    className: (0, _classnames["default"])(className, styles.productFeatures)
  }, containerProps), productFeatures.map(function (productProps) {
    return /*#__PURE__*/_react["default"].createElement(_ProductListItem.ProductListItem, _extends({}, productProps, {
      namespace: namespace
    }));
  }));
};
CardProductFeatures.propTypes = {
  productFeatures: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string,
    icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
    iconColor: _propTypes["default"].string,
    styles: _propTypes["default"].objectOf(_propTypes["default"].string),
    children: _propTypes["default"].node
  })).isRequired,
  className: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string)
};
CardProductFeatures.defaultProps = {
  className: '',
  namespace: '',
  styles: {}
};